import { Component, OnInit } from '@angular/core';
import { TokenControlService } from "../../services/state/tokenControl.service";
import { SyncService } from "../../services/data/sync.service";
import { SyncDataDTO } from "../../model/sync";
import { TranslateService } from '@ngx-translate/core';
import { ConfigurationControlService } from "../../services/configuration/configurationControl.service";

@Component({
  selector: 'app-data-sync',
  templateUrl: './data-sync.component.html',
  styleUrls: ['./data-sync.component.css']
})
export class DataSyncComponent {

    //Flag que se activa mientras se realiza el proceso de sincrinizacion
    public syncing : boolean;

    //Indica el exito en la sincronizacion
    private success : boolean;

    //Indica cuando ya se ha realizado una sincronizacion
    public doneSync  : boolean;

    //contiene el resumen del proceso de sincronizacion
    public dataSync : SyncDataDTO;

    //indica cuando ya no hay elementos para sincronizar
    public alreadySynced: boolean;

    //Constructor de la clase
    constructor( private _tokenController: TokenControlService,
                private _syncDataService: SyncService,
                private _translateService: TranslateService,
                private _configurationControlService : ConfigurationControlService
                ){
                    this.success = false;
                    this.syncing = false;
                    this.doneSync = false;
                    this.alreadySynced = false;
                    this.dataSync = new SyncDataDTO(false,0,0,false);

                    this._translateService.addLangs(["es", "en"]);
                    this._translateService.setDefaultLang(this._configurationControlService.examConfiguration.language);
                    this._translateService.use(this._configurationControlService.examConfiguration.language);
                }

    //Funcion que sincroniza las respuestas, invoca una promesa del servicio
    //de sincronizacion y cuando el servicio resuelve la promesa presenta
    //el resumen del proceso
    public sinchronizeAnswers(){
         this.syncing = true;
         let self = this;
        this._syncDataService.syncData(this._tokenController.token.token, 
            this._tokenController.token.tokenId).then(
            res => {
                if (!res.errors){
                    this.success = true;
                }
                self.dataSync = res;
                this.syncing =false;
                this.doneSync = true;
                if(res.registers == 0){
                    self.alreadySynced = true
                }
            }
        );
    }

    //Funcion que se encarga de limpiar los flags de control y de invocar
    //nuevamente el proceso de sincronizacion
    public retry(){
        this.success = false;
        this.syncing = false;
        this.doneSync = false;
        this.dataSync = new SyncDataDTO(false,0,0,false);
    }

}
